import { useJurisdiction } from "@/hooks/useJurisdiction";
import { COUNTRY_CHOICES } from "@/lib/jurisdiction";
import { useLocale } from "@/i18n/locale-context";

export function CountrySelector() {
  const { country, setManualCountry } = useJurisdiction();
  const { locale } = useLocale();
  const current = COUNTRY_CHOICES.find((c) => c.code === country) ?? COUNTRY_CHOICES[0];
  const nameKey = locale === "fr" ? "nameFr" : locale === "nl" ? "nameNl" : "nameEn";
  return (
    <label className="inline-flex items-center gap-2 text-xs text-muted-foreground">
      <span aria-hidden>{current.flag}</span>
      <select
        value={country ?? ""}
        onChange={(e) => setManualCountry(e.target.value)}
        className="bg-transparent border border-foreground/10 rounded-md px-2 py-1 text-xs"
        aria-label="Country"
      >
        {COUNTRY_CHOICES.map((c) => (
          <option key={c.code} value={c.code}>
            {c.flag} {c[nameKey as "nameFr" | "nameEn" | "nameNl"]}
          </option>
        ))}
      </select>
    </label>
  );
}
